export const REQUEST_ENDPOINT_ZAPPIER_FERIA_TAPICERIA =
  "https://hooks.zapier.com/hooks/catch/10364333/bijv57l/"
